import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ContactForm } from '../../../models/contact-form';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  mail(contactForm: ContactForm): Observable<any> {
    return this.http.post(environment.emailApiURL, contactForm);
  }
}
